import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "login-common-style Code" }
const _hoisted_2 = { class: "email" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("em", null, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "validation2"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "validation",
  style: {"margin-bottom":"10px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("em", null, null, -1)

import { ref, reactive, computed } from "vue";
import { ElMessage } from "element-plus";
import { getAuthToken, getAccoutCode } from "@/api/login";
import { useRouter } from "vue-router";
import store from "@/store";
import i18n from "@/lang";
import license from "@/utils/license";
import { setCookie } from "@/utils/cookies";
import { isEmail, goToNext, isPhone } from "@/utils/index";
import { isNoviceuidance } from "@/utils/driver";
import { ImageCodeType, AuthTokenType } from "@/types/login";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  emits: ["handleAccount"],
  setup(__props, { emit: emits }) {

const router = useRouter();
const forgetPass = () => {
  store.commit("hideLogin");
  router.push({ name: "forgetPassword" });
};
const loginFormMo = reactive({
  iphoneNumber: "",
  passward: "",
  inputCode: "",
});

const getAccoutCodeData = reactive({
  image: "",
  isVerification: 0,
  code: "",
  isError: false,
});
const isMobile = store.state.isMobile;
const isAccoutCode = ref(false);

// 判断当前用户是否显示曝光页
const activePageState = computed(() => store.state.activePageState);
const changeDialogState = () => {
  if (activePageState.value == false) {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    document.getElementsByTagName("body")[0].classList.add("stop-scroll-top");
    store.commit("isShowActivePage", true);
  }
};

//账号密码登录
const evetnLogin = async () => {
  let params = `grant_type=mobile_password&verificationCode=${
    getAccoutCodeData.code
  }&mobile=${loginFormMo.iphoneNumber}&password=${license.publicEncryptLarge(
    loginFormMo.passward
  )}&account_type=`;

  if (!loginFormMo.iphoneNumber) {
    ElMessage.error(i18n.global.t("login.please_enter_email_phone"));
    return;
  }
  if (!loginFormMo.passward) {
    ElMessage.error(i18n.global.t("user_center.password_none"));
    return;
  }

  if (loginFormMo.iphoneNumber.indexOf("@") !== -1) {
    params = `grant_type=email_password&verificationCode=${
      getAccoutCodeData.code
    }&email=${loginFormMo.iphoneNumber}&password=${license.publicEncryptLarge(
      loginFormMo.passward
    )}&account_type=`;
    if (!isEmail(loginFormMo.iphoneNumber)) {
      ElMessage.error(i18n.global.t("login.please_enter_the_account"));
      return;
    }
  } else {
    if (!isPhone(loginFormMo.iphoneNumber)) {
      ElMessage.error(i18n.global.t("login.please_enter_the_account"));
      return;
    }
  }
  if (isAccoutCode.value == false) {
    accoutCodeFn();
  }
  getAuthToken(params).then((res: AuthTokenType) => {
    if (res.code == 0) {
      let data = res.data;
      setCookie("token", data.access_token);
      loginFormMo.iphoneNumber = "";
      loginFormMo.inputCode = "";
      loginFormMo.passward = "";
      store.dispatch("getUserInfo");
      goToNext("home");
      if (!isMobile) {
        setTimeout(() => {
          isNoviceuidance();
        }, 1500);
      } else {
        changeDialogState();
      }
    } else {
      accoutCodeFn();
    }
  });
};
const accoutCodeFn = async () => {
  var accoutCode: ImageCodeType = await getAccoutCode({
    account: loginFormMo.iphoneNumber,
  });
  if (accoutCode.data.isVerification == 1) {
    getAccoutCodeData.image = `data:image/png;base64,${accoutCode.data.image}`;
    getAccoutCodeData.isVerification = accoutCode.data.isVerification;
    isAccoutCode.value = true;
    return;
  }
};

const handleAccount = () => {
  emits("handleAccount");
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_input, {
        modelValue: loginFormMo.iphoneNumber,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginFormMo.iphoneNumber) = $event)),
        placeholder: _ctx.$t('login.login_email_iphone'),
        clearable: ""
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    (isAccoutCode.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("em", _hoisted_5))
            : _createCommentVNode("", true),
          _createVNode(_component_el_input, {
            onkeyup: "value=value.replace(/[^\\d]/g,'')",
            modelValue: getAccoutCodeData.code,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((getAccoutCodeData.code) = $event)),
            placeholder: _ctx.$t('user_center.please_code'),
            maxlength: "4"
          }, null, 8, ["modelValue", "placeholder"]),
          _createElementVNode("img", {
            src: getAccoutCodeData.image,
            alt: ""
          }, null, 8, _hoisted_6),
          _createElementVNode("a", {
            href: "javascript:;",
            onClick: accoutCodeFn
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createVNode(_component_el_input, {
          modelValue: loginFormMo.passward,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loginFormMo.passward) = $event)),
          type: "password",
          placeholder: _ctx.$t('login.password_error_text'),
          "show-password": "",
          onKeyup: _withKeys(evetnLogin, ["enter","native"])
        }, null, 8, ["modelValue", "placeholder", "onKeyup"])
      ], 32)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["forget", _unref(isMobile) ? 'flex-between' : ''])
    }, [
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "default-color",
            onClick: handleAccount
          }, _toDisplayString(_ctx.$t("login.sign_with_code")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        onClick: forgetPass,
        class: "default-color"
      }, _toDisplayString(_ctx.$t("login.forgot_password")), 1)
    ], 2),
    _createElementVNode("button", {
      class: "btn mobile-btn-shadow",
      onClick: evetnLogin
    }, _toDisplayString(_ctx.$t("login.login_in")), 1)
  ]))
}
}

})